import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPersonBurst, faPersonDress, faPersonRunning, faUser} from "@fortawesome/free-solid-svg-icons";

export const isAdmin = (user) => {
    return user && (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_SUPER_ADMIN"));
}

export const getUtilisateurRoleLabel = (role) => {
    // Vérifier si role est un tableau
    if (Array.isArray(role)) {
        return role.map(r => {
            switch (r) {
                case "ROLE_USER":
                    return "Utilisateur";
                case "ROLE_COACH":
                    return "Coach";
                case "ROLE_REFERENT":
                    return "Référent";
                case "ROLE_ADMIN":
                    return "Admin";
                case "ROLE_SUPER_ADMIN":
                    return "Super Admin";
                default:
                    return "Inconnu";
            }
        }).join(", ");
    }

    switch (role) {
        case "ROLE_USER":
            return "Utilisateur";
        case "ROLE_COACH":
            return "Coach";
        case "ROLE_REFERENT":
            return "Référent";
        case "ROLE_ADMIN":
            return "Admin";
        case "ROLE_SUPER_ADMIN":
            return "Super Admin";
        default:
            return "Inconnu";
    }
}

export const getUtilisateurRoleIcon = (role) => {
    switch (role) {
        case "ROLE_USER":
            return <FontAwesomeIcon icon={faUser} />;
        case "ROLE_COACH":
            return <FontAwesomeIcon icon={faPersonRunning} />;
        case "ROLE_REFERENT":
            return <FontAwesomeIcon icon={faPersonDress} />;
        case "ROLE_ADMIN":
            return <FontAwesomeIcon icon={faPersonBurst} />;
        case "ROLE_SUPER_ADMIN":
            return <FontAwesomeIcon icon={faPersonBurst} />;
        default:
            return <FontAwesomeIcon icon={faUser} />;
    }
}